/**
 * Mapping of screen names to their corresponding page names.
 * @type {object}
 */
const paths = {
  auth: {
    login: '/login',
    register: '/register',
    forgetPassword: '/forgot-password',
    afterLogin: '/fill-your-information',
  },
  content: {
    home: '/',
    afterLogin: '/after-login',
    calculators: '/calculators',
    pdfViewer: '/pdf',
    tabNews: '/tab-news',
    article: '/article',
    news: '/news',
    search: '/search',
    drugs: '/drugs',
    summaries: '/summaries',
    favorite: '/favorite',
    contactUs: '/contact-us',
    viewNote: '/view-note',
    editNote: '/edit-note',
    notes: '/notes',
    chooseYourSpeciality: '/choose-your-speciality',
    settings: '/settings',
    genioChat: '/genio-chat',
    profile: '/profile',
    privacyPolicy: '/privacy-policy',
    privacyPolicyForm: '/privacy-policy-form',
    termsConditions: '/terms-and-conditions',
    logout: '/logout',
  },
  shared: {
    notFound: '*',
  },
};

export default paths;
